export default {
  customers: (state) => state.customers,
  loading: (state) => state.loading,
  customersCount: (state) => state.customersCount,
};
